import { LOCALE_COOKIE_KEY } from '@/utils/constants'
export default defineNuxtRouteMiddleware(() => {
  useCookie(LOCALE_COOKIE_KEY).value = useLocale()
})
